module.exports = __webpack_public_path__ + "img/economia_bronze.339f3011.png";